'use client';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

import { cn } from '../../lib/utils';
import { Check } from '@crabs-ai/web-icons';

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'group flex items-center justify-center rounded-[4px] border shadow-xs disabled:pointer-events-none',
        'data-[state=checked]:border-none data-[state=checked]:bg-sys-style-primary-default data-[state=checked]:text-primary-foreground data-[state=checked]:hover:bg-sys-style-primary-deep data-[state=checked]:active:bg-sys-style-primary-deeper',
        'transition-all data-[size=medium]:size-[24px] data-[size=small]:size-[20px]',
        'hover:bg-sys-style-neutral-lightest active:bg-sys-style-neutral-light',
        'disabled:bg-sys-style-neutral-light data-[state=checked]:disabled:bg-sys-style-neutral-light',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className={cn(
          'flex items-center justify-center',
          'group-data-[size=medium]:size-[24px] group-data-[size=small]:size-[20px]',
        )}
      >
        <Check
          className={cn(
            'group-data-[size=small]:[&>svg]:size-[20px]',
            'group-data-[size=medium]:[&>svg]:size-[24px]',
            '[&>g>path]:fill-sys-cont-none-light',
          )}
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox as RadixCheckbox };
